<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: 'Ring',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    },
    colorList: {
      type: Array,
      default() {
        return ["#1d89ff", "#00cdff", "#4be8ca", "#eecf50", "#ff7352"]
        //return ["#8d7fec", "#5085f2", "#e75fc3", "#f87be2", "#f2719a", "#fca4bb", "#f59a8f", "#fdb301", "#57e7ec", "#cf9ef1"];
      }
    },
    chartData: {
      type: Array,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      var option = {
        color: this.colorList,
        title: [
          {
            show: false,
            text: '合计',
            subtext: 12312 + '个',
            textStyle: {
              fontSize: 14,
              color: '#cbeeff'
            },
            subtextStyle: {
              fontSize: 12,
              color: '#cbeeff'
            },
            textAlign: 'center',
            x: '34%',
            y: '38%'
          }
        ],
        tooltip: {
          trigger: 'item',
          formatter: function(parms) {
            var str =
              parms.marker +
              '' +
              parms.data.name +
              '</br>' +
              '数量：' +
              parms.data.value +
              '</br>' +
              '占比：' +
              parms.percent +
              '%'
            return str
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 20,
          align: 'left',
          top: 10,
          height: 190,
          y: "center",
          itemGap: 12,
          icon: "rect",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#cbeeff"
          }
        },
        series: [
          {
            type: 'pie',
            center: ['34%', '49%'],
            radius: ['42%', '64%'],
            clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: 'outter',
                formatter: function(parms) {
                  return parms.data.legendname
                }
              }
            },
            labelLine: {
              normal: {
                length: 5,
                length2: 3,
                smooth: true
              }
            },
            data: this.chartData
          }
        ]
      }
      this.chart = this.$echarts.init(document.getElementById(this.id))
      this.chart.setOption(option)
    }
  }
}
</script>
<style scoped lang="less"></style>
